import { HeroRoster } from '../../generated/prisma';

export default function getNumUnlockedHeroes(hero_roster: HeroRoster) {
  return Object.values(hero_roster).filter((h) => (h?.level ?? 0) > 0).length;
}
